import BankOutlined from '@ant-design/icons/BankOutlined'
import CloseOutlined from '@ant-design/icons/CloseOutlined'
import DeleteOutlined from '@ant-design/icons/DeleteOutlined'
import FileTextOutlined from '@ant-design/icons/FileTextOutlined'
import PaperClipOutlined from '@ant-design/icons/PaperClipOutlined'
import PlusOutlined from '@ant-design/icons/PlusOutlined'
import TeamOutlined from '@ant-design/icons/TeamOutlined'
import UploadOutlined from '@ant-design/icons/UploadOutlined'
import UserOutlined from '@ant-design/icons/UserOutlined'
import {
  Avatar,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Popconfirm,
  Progress,
  Row,
  Select,
  Space,
  Tag,
  Tooltip,
  Typography,
  Upload,
  message,
} from 'antd'
import dayjs from 'dayjs'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { Document } from 'react-pdf'
import { useHistory } from 'react-router-dom'
import { blue, redPrimary, yellowPrimary } from '../../../color'
import { TRUC_COMMAND } from '../../../command_constant'
import AccessControlAction from '../../../components/AccessControlAction'
import { AvatarHasName } from '../../../components/Common/Avatar'
import { subStringAvatar } from '../../../components/Common/CellText'
import { DebounceSelect } from '../../../components/DebounceSelect'
import EmptyContent from '../../../components/EmptyContent'
import PopupRenameFile from '../../../components/PopupRenameFile/PopupRenameFile'
import PopupSign from '../../../components/PopupSign/PopupSign'
import SelectGroupPopupTruc from '../../../components/SelectGroupPopupTruc/SelectGroupPopupTruc'
import SelectPeoplePopupTruc from '../../../components/SelectPeoplePopupTruc/SelectPeoplePopupTruc'
import { systemName, envName } from '../../../config'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DATE_TIME_FORMAT_DEFAULT,
  DIGITAL_SIGN_PROVIDER,
  DIGITAL_TYPE_SIGN_SYSTEM,
  DOCUMENT_TYPE,
  ELECTRONIC_DOCUMENT_STATUS,
} from '../../../constants'
import utils from '../../../utils'
import validator from '../../../validator'
import AuthoritiesActionModalOutgoing from '../../AuthoritiesPage/AuthoritiesActionModalOutgoing'
import {
  FormActionFooter,
  SelectList,
  SelectTitle,
  UploadFileListItem,
  UploadFileListWrapper,
} from './InternalDocumentOutgoingDocCreatePageStyled'
import config from '../../../config'
import CrawlerRequest from '../../../requests/CrawlerRequest'
import SyncImsatCredentialsModal from '../../../components/Shared/SyncImsatCredentialsModal'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../../components/SelectGroupPopup/SelectGroupPopup'

const IMSAT_TOKEN_KEY = 'imsat_outgoing_access_token'
const IMSAT_TIMESTAMP_KEY = 'imsat_outgoing_token_timestamp'
const IMSAT_USERNAME_KEY = 'imsat_outgoing_username'
const IMSAT_TOKEN_TTL_MS = 5 * 60 * 1000 // 5 minutes (300 seconds)
const IMSAT_FOLLOWER_COMPANY_NAME = 'vien khoa hoc cong nghe mo'

const { apiUrl } = config
const { Option } = Select
const { TextArea } = Input
const { Title } = Typography

const InternalDocumentOutgoingDocCreateForm = props => {
  const {
    selectPeopleStore,
    connectedDocumentStore,
    userTrucStore,
    internalDocumentStore,
    fileStore,
    bookStore,
    authorityStore,
    loadingAnimationStore,
    companyStore,
    authenticationStore,
    signedDocumentStore,
    accountStore,
    fileRelease,
    fileReleaseAttachList,
    isReleaseDocument,
    electronicDocumentStore,
    handleCancel,
    cateStore,
    ScanPdfStore,
    sameDocumentStore,
  } = props

  const { listOrgan } = cateStore

  const history = useHistory()
  const { selectedElectronicDocument } = electronicDocumentStore

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    clearSelected,
  } = selectPeopleStore

  const { accountList } = accountStore
  const {
    handleOpenSelectUserPopupTruc,
    isVisibleSelectUserPopupTruc,
    handleCancelSelectUserTruc,
    handleCancelSelectGroupTruc,
    selectUserDataTruc,
    selectGroupDataTruc,
    handleOpenSelectGroupPopupTruc,
    isVisibleSelectGroupPopupTruc,
  } = userTrucStore
  const { dataSameDocument } = sameDocumentStore
  const { responseSign } = signedDocumentStore
  const { authorityIssuedsList } = authorityStore
  const { currentUser } = authenticationStore
  const { bookGroupList, bookListOfGroup } = bookStore
  const [form] = Form.useForm()
  const [imsatAuthorityForm] = Form.useForm()

  // For Rename file
  const [fileExt, setFileExt] = useState()
  const [fileTargetRename, setFileTargetRename] = useState()
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] = useState(
    false
  )
  const [fileList, setFileList] = useState([])
  const [fileTrinhKy, setFileTrinhKy] = useState([])
  const [fileTrinhKyDinhKem, setFileTrinhKyDinhKem] = useState([])
  const [annexFileList, setAnnexFileList] = useState(
    selectedElectronicDocument?.annex_attachments || []
  )
  const [noSetFileTrinhKyDinhKem, setNoSetFileTrinhKyDinhKem] = useState(false)

  const [typeRename, setTypeRename] = useState()
  const [selectedBookGroupId, setSelectedBookGroupId] = useState(null)
  const [viewPortPdf, setViewPortPdf] = useState()
  const [fileRender, setFileRender] = useState()
  //
  const [dataSignSavis, setDataSignSavis] = useState()

  // Ký số popup
  const [isVisiblePopupSign, setIsVisiblePopupSign] = useState(false)

  const [selectedUserListTruc, setSelectedUserListTruc] = useState([])

  const [isCreateDocTruc, setIsCreateDocTruc] = useState(false)

  const [
    isVisibleAuthoritiesActionModalOutgoing,
    setIsVisbleAuthoritiesActionModalOutgoing,
  ] = useState(false)

  const [isProcessing, setIsProcessing] = useState(false)
  const [progressPercent, setProgressPercent] = useState(0)
  const [hasProcessedFirstFile, setHasProcessedFirstFile] = useState(false)
  const [pdfScanData, setPdfScanData] = useState(null)
  const [defaultAuthorityIssuedId, setDefaultAuthorityIssuedId] = useState('')

  // IMSAT Outgoing Document Integration State
  const [isSendImsat, setIsSendImsat] = useState(false)
  const [imsatToken, setImsatToken] = useState('')
  const [imsatUsername, setImsatUsername] = useState('')
  const [imsatTokenTimestamp, setImsatTokenTimestamp] = useState(0)

  const [imsatLoginModalVisible, setImsatLoginModalVisible] = useState(false)
  const [imsatPassword, setImsatPassword] = useState('')
  const [imsatRememberPassword, setImsatRememberPassword] = useState(true)
  const [imsatHasSavedPassword, setHasSavedPassword] = useState(false)
  const [imsatLoginLoading, setImsatLoginLoading] = useState(false)
  const [imsatLoginError, setImsatLoginError] = useState('')

  const [imsatBookGroupList, setImsatBookGroupList] = useState([])
  const [imsatBookList, setImsatBookList] = useState([])
  const [selectedImsatBookGroupId, setSelectedImsatBookGroupId] = useState(null)
  const [imsatAuthorityIssuedsList, setImsatAuthorityIssuedsList] = useState([])
  const [imsatAuthorityModalVisible, setImsatAuthorityModalVisible] = useState(
    false
  )
  const [creatingImsatAuthority, setCreatingImsatAuthority] = useState(false)
  const [imsatUserList, setImsatUserList] = useState([])
  const [loadingImsatMetadata, setLoadingImsatMetadata] = useState(false)
  const [loadingImsatBooks, setLoadingImsatBooks] = useState(false)

  const [followerList, setFollowerList] = useState([])
  const [isSendType, setIsSendType] = useState(false)

  const setImsatFollowerCompany = useCallback(() => {
    const company = companyStore.companyList.find(item =>
      item.name
        ?.normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/gi, 'd')
        .toLowerCase()
        .startsWith(IMSAT_FOLLOWER_COMPANY_NAME)
    )
    if (!company) {
      message.error('Không tìm thấy công ty Viện Khoa học Công nghệ Mỏ!')
      return false
    }
    selectPeopleStore.companyCode = company.code
    return true
  }, [companyStore.companyList, selectPeopleStore])

  const handleOpenImsatFollowerUserPopup = useCallback(() => {
    if (!setImsatFollowerCompany()) return
    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.FOLLOWER)
    setIsSendType(true)
  }, [
    handleOpenSelectUserDepartmentPopup,
    setImsatFollowerCompany,
  ])

  const handleOpenImsatFollowerGroupPopup = useCallback(() => {
    if (!setImsatFollowerCompany()) return
    handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
  }, [handleOpenSelectGroupPopup, setImsatFollowerCompany])

  useEffect(() => {
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  useEffect(() => {
    return () => {
      clearSelected()
    }
  }, [])

  const getSavedImsatToken = useCallback(() => {
    try {
      const token = sessionStorage.getItem(IMSAT_TOKEN_KEY)
      const timestamp = Number(sessionStorage.getItem(IMSAT_TIMESTAMP_KEY))
      const username = sessionStorage.getItem(IMSAT_USERNAME_KEY) || ''
      if (token && timestamp && Date.now() - timestamp < IMSAT_TOKEN_TTL_MS) {
        return { token, username, timestamp, isValid: true }
      }
    } catch (e) {
      console.error(e)
    }
    return { token: null, username: '', timestamp: 0, isValid: false }
  }, [])

  const loadImsatMetadata = useCallback(async (token, username) => {
    setLoadingImsatMetadata(true)
    try {
      const [bgResp, aiResp] = await Promise.all([
        CrawlerRequest.getImsatBookGroups(username, token),
        CrawlerRequest.getImsatAuthorityIssueds(username, token),
      ])

      const bgData = bgResp.data?.data || bgResp.data || []
      setImsatBookGroupList(Array.isArray(bgData) ? bgData : [])

      const aiData = aiResp.data?.data || aiResp.data || []
      const authorityIssueds = Array.isArray(aiData) ? aiData : []
      setImsatAuthorityIssuedsList(authorityIssueds)
      return authorityIssueds
    } catch (err) {
      console.error('Failed to load IMSAT metadata:', err)
      message.error('Không thể tải danh mục từ IMSAT. Vui lòng thử lại!')
      return null
    } finally {
      setLoadingImsatMetadata(false)
    }
  }, [])

  const handleCreateImsatAuthorityIssued = useCallback(
    async ({ name }) => {
      const authorityName = name.trim()
      const saved = getSavedImsatToken()
      const token = imsatToken || saved.token
      const username = imsatUsername || saved.username
      if (!token || !username) {
        message.error('Vui lòng đăng nhập IMSAT trước khi tạo cơ quan ban hành!')
        return
      }

      setCreatingImsatAuthority(true)
      try {
        const response = await CrawlerRequest.createImsatAuthorityIssued(
          authorityName,
          username,
          token
        )
        if (!response.data?.success) {
          throw new Error(
            response.data?.error || 'Không thể tạo cơ quan ban hành IMSAT!'
          )
        }

        const authorityIssueds = await loadImsatMetadata(token, username)
        const createdAuthority = authorityIssueds?.find(
          authority =>
            authority.name?.trim().toUpperCase() ===
            authorityName.toUpperCase()
        )
        if (createdAuthority) {
          form.setFieldsValue({
            imsat_authority_issued_id: createdAuthority.id,
          })
          message.success('Tạo cơ quan ban hành IMSAT thành công!')
        } else {
          message.warning(
            'Đã tạo cơ quan ban hành IMSAT nhưng chưa tải lại được danh sách. Vui lòng làm mới dữ liệu IMSAT.'
          )
        }

        setImsatAuthorityModalVisible(false)
        imsatAuthorityForm.resetFields()
      } catch (err) {
        console.error('Failed to create IMSAT authority issued:', err)
        message.error(
          err.response?.data?.error ||
            err.response?.data?.message ||
            err.message ||
            'Không thể tạo cơ quan ban hành IMSAT!'
        )
      } finally {
        setCreatingImsatAuthority(false)
      }
    },
    [
      form,
      getSavedImsatToken,
      imsatAuthorityForm,
      imsatToken,
      imsatUsername,
      loadImsatMetadata,
    ]
  )

  const handleSelectImsatBookGroupId = useCallback(
    async bookGroupId => {
      form.setFieldsValue({
        imsat_book_id: undefined,
      })
      setSelectedImsatBookGroupId(bookGroupId)
      if (!bookGroupId) {
        setImsatBookList([])
        return
      }
      setLoadingImsatBooks(true)
      try {
        const saved = getSavedImsatToken()
        const token = imsatToken || saved.token
        const uname = imsatUsername || saved.username
        const resp = await CrawlerRequest.getImsatBooks(
          bookGroupId,
          uname,
          token
        )
        const books = resp.data?.data || resp.data || []
        setImsatBookList(Array.isArray(books) ? books : [])
      } catch (err) {
        console.error('Failed to get IMSAT books:', err)
        message.error('Không thể tải danh sách sổ văn bản IMSAT!')
        setImsatBookList([])
      } finally {
        setLoadingImsatBooks(false)
      }
    },
    [form, getSavedImsatToken, imsatToken, imsatUsername]
  )

  const openImsatLoginModal = useCallback(
    async overrideUsername => {
      const uname = (
        (typeof overrideUsername === 'string' && overrideUsername) ||
        imsatUsername ||
        currentUser?.username ||
        ''
      ).trim()

      setImsatUsername(uname)
      setImsatPassword('')
      setImsatLoginError('')
      setImsatRememberPassword(true)
      setImsatLoginModalVisible(true)

      try {
        const resp = await CrawlerRequest.getCredentials()
        const credList = Array.isArray(resp.data?.data)
          ? resp.data.data
          : Array.isArray(resp.data)
          ? resp.data
          : []

        let userCred = null
        if (uname) {
          userCred = credList.find(
            c =>
              c.username?.trim()?.toLowerCase() === uname.toLowerCase() &&
              (String(c.is_active) === '1' || c.is_active === true)
          )
        }
        if (!userCred && credList.length > 0) {
          userCred =
            credList.find(
              c => String(c.is_active) === '1' || c.is_active === true
            ) || credList[0]
          if (userCred?.username) {
            setImsatUsername(userCred.username)
          }
        }

        if (userCred) {
          setHasSavedPassword(true)
          setImsatPassword(userCred.password || '')
          setImsatRememberPassword(true)
        } else {
          setHasSavedPassword(false)
          setImsatPassword('')
        }
      } catch (err) {
        console.error('Failed to get crawler credentials:', err)
        setHasSavedPassword(false)
        setImsatPassword('')
      }
    },
    [currentUser, imsatUsername]
  )

  const handleCancelImsatLogin = useCallback(() => {
    setImsatLoginModalVisible(false)
    setImsatLoginError('')
    const saved = getSavedImsatToken()
    if (!saved.isValid) {
      setIsSendImsat(false)
    }
  }, [getSavedImsatToken])

  const handleImsatLogin = useCallback(async () => {
    const username = (imsatUsername || '').trim()
    const password = imsatPassword || ''

    if (!username) {
      setImsatLoginError('Vui lòng nhập tên đăng nhập IMSAT!')
      return
    }
    if (!password && !imsatHasSavedPassword) {
      setImsatLoginError('Vui lòng nhập mật khẩu tài khoản IMSAT!')
      return
    }

    setImsatLoginLoading(true)
    setImsatLoginError('')
    try {
      const verifyResp = await CrawlerRequest.verifyCredentials(
        username,
        password,
        imsatRememberPassword
      )

      if (!verifyResp.data?.success) {
        setImsatLoginError(
          verifyResp.data?.error ||
            'Tài khoản hoặc mật khẩu IMSAT không chính xác hoặc đã hết hạn.'
        )
        return
      }

      const token =
        verifyResp.data?.data?.token ||
        verifyResp.data?.token ||
        verifyResp.data?.data?.access_token ||
        verifyResp.data?.access_token

      if (!token) {
        setImsatLoginError('Không nhận được token xác thực từ máy chủ IMSAT.')
        return
      }

      const now = Date.now()
      sessionStorage.setItem(IMSAT_TOKEN_KEY, token)
      sessionStorage.setItem(IMSAT_TIMESTAMP_KEY, String(now))
      sessionStorage.setItem(IMSAT_USERNAME_KEY, username)

      setImsatToken(token)
      setImsatTokenTimestamp(now)
      setIsSendImsat(true)
      setImsatLoginModalVisible(false)
      message.success('Đăng nhập tài khoản IMSAT thành công!')

      await loadImsatMetadata(token, username)
    } catch (err) {
      console.error('IMSAT login error:', err)
      setImsatLoginError(
        err.vi || err.message || 'Không thể kết nối đến máy chủ IMSAT!'
      )
    } finally {
      setImsatLoginLoading(false)
    }
  }, [
    imsatHasSavedPassword,
    imsatPassword,
    imsatRememberPassword,
    imsatUsername,
    loadImsatMetadata,
  ])

  const onChangeCheckboxImsat = useCallback(
    async e => {
      const checked = e.target.checked
      if (!checked) {
        setIsSendImsat(false)
        clearSelected()
        form.setFieldsValue({
          imsat_book_group_id: undefined,
          imsat_book_id: undefined,
          imsat_authority_issued_id: undefined,
        })
        return
      }

      const saved = getSavedImsatToken()
      if (saved.isValid) {
        setIsSendImsat(true)
        setImsatToken(saved.token)
        setImsatTokenTimestamp(saved.timestamp)
        setImsatUsername(saved.username)
        await loadImsatMetadata(saved.token, saved.username)
      } else {
        await openImsatLoginModal()
      }
    },
    [form, getSavedImsatToken, loadImsatMetadata, openImsatLoginModal]
  )

  useEffect(() => {
    const authorityIssuedName = dataSameDocument?.authorityIssuedName
    const authorityIssuedId = authorityIssuedsList.find(
      ({ name }) =>
        name?.trim()?.toUpperCase() ===
        authorityIssuedName?.trim()?.toUpperCase()
    )?.id
    setDefaultAuthorityIssuedId(authorityIssuedId)

    const authority_issued_id = form.getFieldValue('authority_issued_id')

    if (!authority_issued_id && authorityIssuedId) {
      console.log(authorityIssuedId)
      form.setFieldsValue({ authority_issued_id: authorityIssuedId })
    }
  }, [dataSameDocument, authorityIssuedsList])

  const createFileFromUrl = async (id, fileName) => {
    const url = `${apiUrl}/api/v1/images/${id}?access_token=${
      JSON.parse(authenticationStore.appToken).access_token
    }`
    const response = await fetch(url)

    const data = await response.blob()
    const file = new File([data], fileName, {
      type: data?.type,
    })
    const fakeUploadEvent = {
      uid: `rc-upload-${Date.now()}`, // Tạo ID duy nhất
      name: fileName,
      status: 'done', // Đánh dấu là đã xong
      originFileObj: file, // Đưa file chuẩn vào đây
      percent: 0,
      isSigned: false,
      type: data?.type,
    }
    return fakeUploadEvent
  }

  useEffect(() => {
    ;(async () => {
      setFileList([])
      if (dataSameDocument?.attachments?.length > 0) {
        const fileObjects = await Promise.all(
          dataSameDocument?.attachments.map(file =>
            createFileFromUrl(file.fileId, file.name)
          )
        )
        const files = fileObjects.filter(file => file !== null)
        setFileList(files)
        // 2. Cập nhật vào Form để vượt qua rule "required"
        form.setFieldsValue({
          attachments: files,
        })
      }
    })()
  }, [dataSameDocument])

  useEffect(() => {
    const fetchData = async () => {
      // Validate prerequisites before processing
      if (!fileList || !Array.isArray(fileList) || fileList.length !== 1) {
        console.warn('Invalid fileList:', fileList)
        return
      }

      if (hasProcessedFirstFile) {
        console.log('File already processed, skipping...')
        return
      }

      const file = fileList[0]
      if (!file || !file.originFileObj || !file.name.endsWith('.pdf')) {
        console.error('Invalid file object:', file)
        // message.error('Chỉ hỗ trợ file PDF. Vui lòng chọn lại file.')
        return
      }

      setIsProcessing(true)
      setProgressPercent(0)

      const interval = setInterval(() => {
        setProgressPercent(prev => {
          if (prev >= 90) return prev
          return prev + 10
        })
      }, 500)

      try {
        // Validate ScanPdfStore exists and has required methods
        if (!ScanPdfStore || typeof ScanPdfStore.getOcrStatus !== 'function') {
          throw new Error('ScanPdfStore service không khả dụng')
        }

        const limitRequest = await ScanPdfStore.getOcrStatus()

        // Validate limit request response
        if (
          !limitRequest ||
          !limitRequest.data ||
          typeof limitRequest.data.thisMonthRequestCount === 'undefined'
        ) {
          console.warn('Invalid limit request response:', limitRequest)
          // Continue processing despite invalid response
        } else if (limitRequest.data.thisMonthRequestCount > 799) {
          clearInterval(interval)
          message.error('Đã vượt quá giới hạn 1000 request/tháng')
          setIsProcessing(false)
          setProgressPercent(0)
          return
        }

        // Validate recognizeText method exists
        if (typeof ScanPdfStore.recognizeText !== 'function') {
          throw new Error('Chức năng nhận dạng văn bản không khả dụng')
        }

        // const response = await ScanPdfStore.recognizeText(file.originFileObj)
        const response = []

        // Comprehensive response validation
        if (!response) {
          throw new Error('Không nhận được phản hồi từ server')
        }

        if (!response.data) {
          throw new Error('Phản hồi từ server không chứa dữ liệu')
        }

        if (!response.data.data) {
          throw new Error('Dữ liệu nhận dạng trống')
        }

        // Validate the structure of the returned data
        const responseData = response.data.data
        if (!responseData.raw_data) {
          console.warn('Missing raw_data in response:', responseData)
          throw new Error('Dữ liệu thô không tồn tại')
        }

        setPdfScanData(responseData)
        setProgressPercent(100)
        setHasProcessedFirstFile(true)
      } catch (error) {
        console.error('Error in recognizeText:', error)
        setPdfScanData(null)
        setProgressPercent(0)
        setHasProcessedFirstFile(false)

        // More specific error messages
        const errorMessage =
          error.message || 'Có lỗi xảy ra khi xử lý file. Vui lòng thử lại.'
        message.error(errorMessage)
      } finally {
        clearInterval(interval)
        setIsProcessing(false)
      }
    }

    // Only run in production environment
    if (envName === 'prod' && currentUser?.username !== 'vanthuttatm') {
      return
      // fetchData()
    }
  }, [fileList, ScanPdfStore, hasProcessedFirstFile, envName])

  const parseDocumentData = useCallback(lines => {
    // Validate input data
    if (!lines) {
      console.warn('parseDocumentData: lines is null or undefined')
      return null
    }

    if (!Array.isArray(lines)) {
      console.warn('parseDocumentData: lines is not an array:', typeof lines)
      return null
    }

    if (lines.length === 0) {
      console.warn('parseDocumentData: lines array is empty')
      return null
    }

    // Validate each line object
    const validLines = lines.filter(lineObj => {
      if (!lineObj || typeof lineObj !== 'object') {
        console.warn('Invalid line object:', lineObj)
        return false
      }
      if (typeof lineObj.line !== 'string') {
        console.warn('Line object missing string property:', lineObj)
        return false
      }
      return true
    })

    if (validLines.length === 0) {
      console.warn('No valid lines found after filtering')
      return null
    }

    const document = {
      header: [],
      subject: '',
      date: '',
      body: [],
    }

    let currentSection = 'header'
    let subjectLines = []
    let subjectLineCount = 0
    const maxSubjectLines = 3
    let isQuyetDinhSection = false
    let isBodySection = false

    // Check if document contains "QUYẾT ĐỊNH"
    const isQuyetDinhDoc = validLines.some(lineObj => {
      try {
        return lineObj.line && lineObj.line.includes('QUYẾT ĐỊNH')
      } catch (e) {
        console.warn('Error checking line for QUYẾT ĐỊNH:', e)
        return false
      }
    })

    try {
      if (isQuyetDinhDoc) {
        // Logic for "QUYẾT ĐỊNH" document
        for (let i = 0; i < validLines.length; i++) {
          const lineObj = validLines[i]
          if (!lineObj || !lineObj.line) continue

          const line = lineObj.line.trim()
          if (!line) continue // Skip empty lines

          // Check for document number
          if (line.match(/^(?:Số|Só)[:\s]+[\d\/A-Z-]+/i)) {
            document.header.push(line)
            currentSection = 'subject'
            continue
          }

          // Check for date
          if (
            line.match(/ngày[\s\/]+\d{1,2}\s+tháng\s+\d{1,2}\s+năm\s+\d{4}/i) ||
            line.match(/^(Hà Nội|TP\.|Thành phố).*ngày/i)
          ) {
            if (!document.date) document.date = line
            continue
          }

          // Start of QUYẾT ĐỊNH section
          if (line.includes('QUYẾT ĐỊNH')) {
            isQuyetDinhSection = true
            currentSection = 'subject'
            continue
          }

          // Start of body (when encountering "Điều 1" or "VIỆN TRƯỞNG")
          if (line.match(/^Điều\s+\d+\./) || line.includes('VIỆN TRƯỞNG')) {
            isBodySection = true
            currentSection = 'body'
          }

          // Assign lines to appropriate sections
          if (currentSection === 'header') {
            document.header.push(line)
          } else if (
            currentSection === 'subject' &&
            isQuyetDinhSection &&
            !isBodySection
          ) {
            subjectLines.push(line)
          } else if (currentSection === 'body') {
            document.body.push(line)
          }
        }

        // Join subject lines and clean up
        document.subject = subjectLines
          .filter(
            line =>
              line &&
              !line.match(/ngày[\s\/]+\d{1,2}\s+tháng\s+\d{1,2}\s+năm\s+\d{4}/i)
          )
          .join(' ')
          .trim()
      } else {
        // Logic for non-"QUYẾT ĐỊNH" document (original code with validation)
        for (let i = 0; i < validLines.length; i++) {
          const lineObj = validLines[i]
          if (!lineObj || !lineObj.line) continue

          const line = lineObj.line
          if (!line) continue // Skip empty lines

          // Check for document number patterns
          if (
            line.startsWith('Số:') ||
            line.startsWith('Só:') ||
            line.match(/^(?:Số|Só)\s*:\s*\d+/) ||
            line.match(/^(?:Số|Só)\s+\d+/)
          ) {
            document.header.push(line)
            currentSection = 'subject'
            continue
          }

          if (currentSection === 'subject') {
            // Skip date pattern ONLY in subject section
            if (
              line.match(
                /ngày[\s\/]+\d{1,2}\s+tháng\s+\d{1,2}\s+năm\s+\d{4}/i
              ) ||
              line.match(/^(Hà Nội|TP\.|Thành phố).*ngày/i)
            ) {
              if (!document.date) document.date = line
              continue
            }

            if (subjectLineCount < maxSubjectLines) {
              subjectLines.push(line)
              subjectLineCount++
            } else {
              currentSection = 'body'
              document.body.push(line)
            }
            continue
          }

          // For header and body sections, keep all lines including date patterns
          if (currentSection === 'header') {
            document.header.push(line)
            if (
              line.match(
                /ngày[\s\/]+\d{1,2}\s+tháng\s+\d{1,2}\s+năm\s+\d{4}/i
              ) ||
              line.match(/^(Hà Nội|TP\.|Thành phố).*ngày/i)
            ) {
              if (!document.date) document.date = line
            }
          } else {
            document.body.push(line)
            if (
              line.match(
                /ngày[\s\/]+\d{1,2}\s+tháng\s+\d{1,2}\s+năm\s+\d{4}/i
              ) ||
              line.match(/^(Hà Nội|TP\.|Thành phố).*ngày/i)
            ) {
              if (!document.date) document.date = line
            }
          }
        }

        // Clean up subject by removing any remaining date patterns
        document.subject = subjectLines
          .filter(
            line =>
              line &&
              !line.match(/ngày[\s\/]+\d{1,2}\s+tháng\s+\d{1,2}\s+năm\s+\d{4}/i)
          )
          .join(' ')
          .trim()
      }
    } catch (error) {
      console.error('Error in parseDocumentData:', error)
      return null
    }

    return document
  }, [])

  const safeJsonParse = useCallback(jsonString => {
    if (!jsonString || typeof jsonString !== 'string') {
      console.warn('Invalid JSON string provided:', typeof jsonString)
      return null
    }

    try {
      // First attempt: direct parsing
      return JSON.parse(jsonString)
    } catch (error) {
      console.warn('Direct JSON parse failed, attempting fixes:', error.message)

      try {
        // Second attempt: fix common escape character issues
        let fixedJson = jsonString
          // Fix invalid escape sequences
          .replace(/\\(?!["\\/bfnrt]|u[0-9a-fA-F]{4})/g, '\\\\')
          // Fix unescaped quotes in strings (basic fix)
          .replace(/([^\\])"([^"]*[^\\])"([^,}\]])/g, '$1\\"$2\\"$3')
          // Remove invalid control characters
          .replace(/[\x00-\x1F\x7F]/g, '')

        return JSON.parse(fixedJson)
      } catch (secondError) {
        console.warn('Fixed JSON parse also failed:', secondError.message)

        try {
          // Third attempt: extract JSON-like data using regex
          const jsonMatch = jsonString.match(/\[.*\]/s)
          if (jsonMatch) {
            const extractedJson = jsonMatch[0]
              .replace(/\\(?!["\\/bfnrt]|u[0-9a-fA-F]{4})/g, '\\\\')
              .replace(/[\x00-\x1F\x7F]/g, '')
            return JSON.parse(extractedJson)
          }
        } catch (thirdError) {
          console.error('All JSON parsing attempts failed:', thirdError.message)
        }

        return null
      }
    }
  }, [])

  const extractDataFromRawString = useCallback(
    rawString => {
      if (!rawString || typeof rawString !== 'string') {
        return null
      }

      const extractedData = {}

      try {
        // Extract document number using regex
        const soMatch = rawString.match(/(?:Số|So|S[óoốồổỗộ]):\s*([^\n\r]+)/i)
        if (soMatch) {
          const soValue = soMatch[1].trim()
          const numberMatch = soValue.match(/(\d+)\/(.+)/)
          if (numberMatch) {
            extractedData.incoming_number = numberMatch[1]
            extractedData.document_number = soValue.replace(
              /(N?V?)KHCNM/gi,
              'VKHCNM'
            )
          }
        }

        // Extract title/subject
        const vvMatch = rawString.match(/V\/v[:\s]+([^\n\r]+)/i)
        if (vvMatch) {
          extractedData.title = vvMatch[1].trim()
        }

        // Extract date
        const dateMatch = rawString.match(
          /ngày\s+(\d{1,2})\s+tháng\s+(\d{1,2})\s+năm\s+(\d{4})/i
        )
        if (dateMatch && moment) {
          try {
            const momentDate = moment(
              `${dateMatch[3]}-${dateMatch[2]}-${dateMatch[1]}`
            )
            if (momentDate.isValid()) {
              extractedData.date_issued = momentDate
            }
          } catch (momentError) {
            console.warn(
              'Error creating moment date in alternative extraction:',
              momentError
            )
          }
        }

        return extractedData
      } catch (error) {
        console.error('Error in extractDataFromRawString:', error)
        return null
      }
    },
    [moment]
  )

  let structuredData = null
  let rawDataParsingError = null

  try {
    if (pdfScanData && pdfScanData.raw_data) {
      console.log('Attempting to parse raw_data...')

      const parsedRawData = safeJsonParse(pdfScanData.raw_data)

      if (parsedRawData) {
        console.log('Successfully parsed raw_data, attempting to structure...')
        structuredData = parseDocumentData(parsedRawData)
        if (structuredData) {
          console.log('Successfully structured document data')
        } else {
          console.warn('Failed to structure document data')
        }
      } else {
        rawDataParsingError = 'Không thể phân tích dữ liệu JSON từ server'
        console.error('Failed to parse raw_data after all attempts')

        // Show user-friendly error message
        message.warning(
          'Dữ liệu nhận được có định dạng không hợp lệ. Vui lòng thử lại hoặc liên hệ hỗ trợ.'
        )
      }
    } else {
      console.warn('No pdfScanData or raw_data available')
    }
  } catch (error) {
    console.error('Error in structuredData processing:', error)
    rawDataParsingError = error.message
    structuredData = null

    // Show user-friendly error message
    message.error('Có lỗi xảy ra khi xử lý dữ liệu. Vui lòng thử lại.')
  }

  useEffect(() => {
    if (!structuredData) {
      console.log('No structured data available for form population')

      // If there was a parsing error but we still have some data, try alternative processing
      if (rawDataParsingError && pdfScanData && pdfScanData.raw_data) {
        console.log('Attempting alternative data extraction...')

        try {
          // Try to extract basic information from raw string without JSON parsing
          const rawString = String(pdfScanData.raw_data)
          const extractedData = extractDataFromRawString(rawString)

          if (extractedData && Object.keys(extractedData).length > 0) {
            console.log(
              'Successfully extracted data from raw string:',
              extractedData
            )
            form.setFieldsValue(extractedData)
            message.success('Đã trích xuất được một phần thông tin từ tài liệu')
          }
        } catch (alternativeError) {
          console.error('Alternative extraction also failed:', alternativeError)
        }
      }

      return
    }

    // Validate form exists
    if (!form || typeof form.setFieldsValue !== 'function') {
      console.error('Form object is not available or invalid')
      message.error('Lỗi hệ thống: Form không khả dụng')
      return
    }

    try {
      let rawData = null

      // Safely parse raw data using the safe parser
      if (pdfScanData && pdfScanData.raw_data) {
        rawData = safeJsonParse(pdfScanData.raw_data)
      }

      // ... rest of the existing form population logic remains the same
      // 1. Extract so_hieu và so_den with validation
      let soHieu = ''
      let soDen = ''
      const headerLines = Array.isArray(structuredData.header)
        ? structuredData.header
        : []

      const rawSoHieuLine = headerLines.find(
        line =>
          typeof line === 'string' &&
          (line.startsWith('Số') || line.startsWith('Só'))
      )

      if (rawSoHieuLine) {
        const cleanedLine = rawSoHieuLine.replace(/\s+/g, ' ').trim()
        let match = cleanedLine.match(/(?:Số|So|S[óoốồổỗộ]):\s*(\d+)\/(.+)/i)
        if (match) {
          soDen = match[1]
          soHieu = `${soDen}/${match[2].trim()}`
        } else {
          match = cleanedLine.match(
            /(?:Số|So|S[óoốồổỗộ]):\s*([\d\s]+)\s+([A-Z].+)/i
          )
          if (match) {
            soDen = match[1].replace(/\s+/g, '')
            soHieu = `${soDen}/${match[2].trim()}`
          } else {
            match = cleanedLine.match(/(?:Số|So|S[óoốồổỗộ])\s+(\d+)\s+\/(.+)/i)
            if (match) {
              soDen = match[1]
              soHieu = `${soDen}/${match[2].trim()}`
            } else {
              match = cleanedLine.match(
                /(?:Số|So|S[óoốồổỗộ]):\s*([\d\s]+)\/(.+)/i
              )
              if (match) {
                soDen = match[1].replace(/\s+/g, '')
                soHieu = `${soDen}/${match[2].trim()}`
              } else {
                match = cleanedLine.match(
                  /(?:Số|So|S[óoốồổỗộ])\s+(\d+)\s+([A-Z].+)/i
                )
                if (match) {
                  soDen = match[1]
                  soHieu = `${soDen}/${match[2].trim()}`
                } else {
                  match = cleanedLine.match(
                    /(?:Số|So|S[óoốồổỗộ])\s*:\s*(\d+)\s+([A-Z].+)/i
                  )
                  if (match) {
                    soDen = match[1]
                    soHieu = `${soDen}/${match[2].trim()}`
                  }
                }
              }
            }
          }
        }

        if (!match) {
          const fallbackMatch = cleanedLine.match(
            /(?:Số|So|S[óoốồổỗộ]):\s*(.+)/i
          )
          if (fallbackMatch) {
            const parts = fallbackMatch[1].trim().split(/\s+/)
            if (parts.length >= 2) {
              let numberPart = ''
              let textPart = ''
              let foundText = false
              for (let i = 0; i < parts.length; i++) {
                if (/^\d+$/.test(parts[i]) && !foundText) {
                  numberPart += parts[i]
                } else {
                  foundText = true
                  textPart += (textPart ? ' ' : '') + parts[i]
                }
              }
              if (numberPart && textPart) {
                soDen = numberPart
                soHieu = `${soDen}/${textPart}`
              }
            }
          }
        }
      }

      // Fallback to raw_data if needed
      if (
        (!soHieu || !soDen) &&
        typeof rawData === 'string' &&
        rawData.includes('\n')
      ) {
        const lines = rawData.split('\n')
        for (let line of lines) {
          if (!line || typeof line !== 'string') continue

          const cleanedLine = line.trim()
          if (cleanedLine.startsWith('Số') || cleanedLine.startsWith('Só')) {
            let match = cleanedLine.match(
              /(?:Số|So|S[óoốồổỗộ]):\s*(\d+)\/(.+)/i
            )
            if (match) {
              soDen = match[1]
              soHieu = `${soDen}/${match[2].trim()}`
              break
            } else {
              match = cleanedLine.match(
                /(?:Số|So|S[óoốồổỗộ])\s+(\d+)\s+([A-Z].+)/i
              )
              if (match) {
                soDen = match[1]
                soHieu = `${soDen}/${match[2].trim()}`
                break
              }
            }
          }
        }
      }

      // 2. Extract trich_yeu with validation
      let trichYeu =
        typeof structuredData.subject === 'string' ? structuredData.subject : ''

      // Fallback to raw_data
      if (!trichYeu && typeof rawData === 'string' && rawData.includes('\n')) {
        const lines = rawData.split('\n')
        for (let line of lines) {
          if (
            line &&
            typeof line === 'string' &&
            line.trim().startsWith('V/v')
          ) {
            trichYeu = line.substring(4).trim()
            break
          }
        }
      }

      // 3. Extract ngay_ban_hanh with validation
      const dateRaw =
        typeof structuredData.date === 'string' ? structuredData.date : ''
      const dateMatch = dateRaw?.match(
        /ngày\s+(\d{1,2})\s+tháng\s+(\d{1,2})\s+năm\s+(\d{4})/i
      )

      let momentDate = null
      if (dateMatch && moment) {
        try {
          momentDate = moment(`${dateMatch[3]}-${dateMatch[2]}-${dateMatch[1]}`)
          if (!momentDate.isValid()) {
            console.warn('Invalid moment date created:', momentDate)
            momentDate = null
          }
        } catch (momentError) {
          console.error('Error creating moment date:', momentError)
          momentDate = null
        }
      }

      // Fallback to raw_data for date
      if (!momentDate && rawData && moment) {
        const rawDataString = rawData.toString()
        const dateMatchRaw = rawDataString?.match(
          /ngày\s+(\d{1,2})\s+tháng\s+(\d{1,2})\s+năm\s+(\d{4})/i
        )
        if (dateMatchRaw) {
          try {
            momentDate = moment(
              `${dateMatchRaw[3]}-${dateMatchRaw[2]}-${dateMatchRaw[1]}`
            )
            if (!momentDate.isValid()) {
              momentDate = null
            }
          } catch (momentError) {
            console.error('Error creating fallback moment date:', momentError)
          }
        }
      }

      // Clean up soHieu
      if (soHieu && typeof soHieu === 'string') {
        soHieu = soHieu.replace(/(N?V?)KHCNM/gi, 'VKHCNM')
      }

      // Populate form with validated data
      const formData = {}

      if (soHieu) formData.document_number = soHieu
      // if (soDen) formData.incoming_number = soDen
      if (trichYeu) formData.title = trichYeu
      if (momentDate) formData.date_issued = momentDate

      console.log('Populating form with data:', formData)

      // Only set fields if we have at least some data
      if (Object.keys(formData).length > 0) {
        form.setFieldsValue(formData)
        // message.success('Đã điền thông tin tự động từ tài liệu')
      } else {
        message.warning(
          'Không thể trích xuất thông tin từ tài liệu. Vui lòng nhập thủ công.'
        )
      }
    } catch (error) {
      console.error('Error in form population useEffect:', error)
      message.error(
        'Có lỗi khi điền thông tin vào form. Vui lòng nhập thủ công.'
      )
    }
  }, [pdfScanData, structuredData, form, rawDataParsingError])

  useEffect(() => {
    if (fileRelease) {
      setFileTrinhKy([fileRelease])
    }
  }, [fileRelease])

  useEffect(() => {
    if (fileReleaseAttachList && !noSetFileTrinhKyDinhKem) {
      setFileTrinhKyDinhKem(toJS(fileReleaseAttachList))
    }
  }, [fileReleaseAttachList, noSetFileTrinhKyDinhKem])

  useEffect(() => {
    setSelectedUserListTruc([
      ...toJS(selectUserDataTruc),
      ...toJS(selectGroupDataTruc),
    ])
  }, [selectUserDataTruc, selectGroupDataTruc])

  useEffect(() => {
    if (!responseSign) return
    const {
      fileSignId,
      fileOriginName,
      fileSignName,
    } = responseSign.data.listSignFile[0]
    const newFileList = [...fileList]
    newFileList[dataSignSavis.index] = {
      ...fileList[dataSignSavis.index],
      name: fileSignName,
      id: fileSignId,
      uid: dataSignSavis.file.uid,
      isSigned: true,
      type: 'application/pdf',
    }
    setFileList(newFileList)
  }, [responseSign])

  useEffect(() => {
    return () => {
      userTrucStore.clearStore()
    }
  }, [])

  const handleChangeFile = info => {
    if (info.fileList.length === 0) {
      form.setFieldsValue({ file_upload: undefined })
      setFileList([])
      return
    }
    const filteredFileList = info.fileList.filter(
      (elem, index, fileList) =>
        fileList.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }

  const renderPage = async pdf => {
    const page = await pdf.getPage(1)
    const viewport = page.getViewport({ scale: 1 })
    setViewPortPdf({ height: viewport.height, width: viewport.width })
  }

  const renderDocument = () => {
    return (
      <Document
        noData={null}
        style={{ display: 'none' }}
        file={fileRender?.originFileObj}
        onLoadSuccess={pdf => onDocumentLoadSuccess(pdf)}
      />
    )
  }

  const renderPopupTruc = () => {
    if (localStorage.getItem('jwtTruc') && isCreateDocTruc) {
      return (
        <>
          <SelectPeoplePopupTruc
            isVisibleSelectPeoplePopupTruc={isVisibleSelectUserPopupTruc}
            handleCancelSelectUserTruc={handleCancelSelectUserTruc}
            handleSubmitSelectUserTruc={() =>
              userTrucStore.setIsVisibleSelectUserPopupTruc(false)
            }
          />
          <SelectGroupPopupTruc
            isVisibleSelectGroupPopupTruc={isVisibleSelectGroupPopupTruc}
            handleCancelSelectGroupTruc={handleCancelSelectGroupTruc}
            handleSubmitSelectGroupTruc={() =>
              userTrucStore.setIsVisibleSelectGroupPopupTruc(false)
            }
          />
        </>
      )
    }
  }

  const onDocumentLoadSuccess = pdf => {
    renderPage(pdf, 1)
  }

  const handleBeforeSign = (file, index) => {
    setFileRender(file)
    setDataSignSavis({
      file: file,
      index: index,
    })
  }

  const handleSignSavis = (file, index) => {
    loadingAnimationStore.showSpinner(true)
    const formData = new FormData()
    formData.append('file', file.originFileObj)
    fileStore
      .uploadFile(formData)
      .then(res => {
        const dataSubmit = {
          image: '',
          reason: 'Signed',
          location: 'VietNam',
          provider: DIGITAL_SIGN_PROVIDER,
          contactInfo: '',
          type: DIGITAL_TYPE_SIGN_SYSTEM,
          isVisible: 1,
          page: 1,
          llx: 300,
          lly: 794,
          urx: 590,
          ury: 830,
          listSignFile: [
            {
              fileId: res.data.file_id,
            },
          ],
        }
        signedDocumentStore
          .signDocumentSavis(dataSubmit)
          .then(res => {
            const {
              fileSignId,
              fileOriginName,
              fileSignName,
            } = res.data.listSignFile[0]
            const newFileList = [...fileList]
            newFileList[index] = {
              ...fileList[index],
              name: fileSignName,
              id: fileSignId,
              uid: file.uid,
              isSigned: true,
              type: 'application/pdf',
            }
            setFileList(newFileList)
            loadingAnimationStore.showSpinner(false)
            message.success(`Văn bản "${fileOriginName}" đã được kí`)
          })
          .catch(err => {
            loadingAnimationStore.showSpinner(false)
            return message.error(err?.vi || 'Ký số thất bại!')
          })
      })
      .catch(() => loadingAnimationStore.showSpinner(false))
  }

  const handleRemoveFileFromUploadList = useCallback(
    fileUID => {
      const newFileList = fileList.filter(file => file.uid !== fileUID)
      setFileList(newFileList)
      if (newFileList.length === 0) {
        form.setFieldsValue({
          attachments: [],
        })
        setHasProcessedFirstFile(false)
        setPdfScanData(null)
      }
    },
    [fileList]
  )

  const handleSelectBookGroupId = bookGroupId => {
    if (!bookGroupId) setSelectedBookGroupId(null)
    form.setFieldsValue({
      book_id: undefined,
    })
    form.validateFields(['book_id'])
    setSelectedBookGroupId(bookGroupId)
    loadingAnimationStore.showSpinner(true)
    bookStore
      .getBookByBookGroupId(bookGroupId)
      .finally(() => loadingAnimationStore.showSpinner(false))
  }
  const validateDocumentNumber = async (rule, value) => {
    if (!value || value.trim() === '') {
      return Promise.reject('Cần nhập ký tự, vui lòng không bỏ trống')
    } else if (value < 0) {
      return Promise.reject('Cần nhập số lớn hơn 0!')
    } else {
      if (value === undefined) return
      try {
        let bookId = form.getFieldValue('book_id')
        if (!bookId) {
          return Promise.reject('Chưa chọn sổ văn bản')
        }
        const response = await internalDocumentStore.getWarningDocumentNumber(
          null,
          form.getFieldValue('book_id'),
          value,
          'OUTGOING'
        )
        if (response.data.status === 'WARNING') {
          return Promise.reject(response.data.message)
        } else {
          return Promise.resolve()
        }
      } catch (error) {
        console.log(error)
        message.error(error?.vi || 'Đã có lỗi xảy ra!')
      }
    }
  }

  const onFinish = async values => {
    if (isCreateDocTruc && selectedUserListTruc.length === 0) {
      return message.warning('Vui lòng chọn công ty nhận!')
    }

    if (isSendImsat) {
      const saved = getSavedImsatToken()
      if (!saved.isValid) {
        message.warning(
          'Phiên làm việc IMSAT đã hết hạn (sau 5 phút). Vui lòng đăng nhập lại để gửi văn bản sang IMSAT.'
        )
        await openImsatLoginModal()
        return
      }
      if (
        !values.imsat_book_group_id ||
        !values.imsat_book_id ||
        !values.imsat_authority_issued_id
      ) {
        return message.warning(
          'Vui lòng chọn đầy đủ nhóm sổ, sổ văn bản và cơ quan ban hành IMSAT!'
        )
      }
    }
    const selectUserDataValue = selectUserDataTruc.map(user => {
      return {
        id: user.id,
        type: ASSIGNEE_TYPE.USER,
      }
    })

    const selectGroupDataValue = selectGroupDataTruc.map(group => {
      return {
        id: group.id,
        type: ASSIGNEE_TYPE.GROUP,
      }
    })

    const listUserToValue = [...selectUserDataValue, ...selectGroupDataValue]

    const {
      agency_external,
      authority_issued_id,
      book_group_id,
      book_id,
      date_issued,
      document_number,
      document_type,
      sign_date,
      signer,
      agency_issued,
      title,
      urgency_level,
      receive_address,
      organizations,
    } = values

    const uploadFileList = fileList
      .filter(file => !file.isSigned)
      .filter(
        (elem, index, fileList) =>
          fileList.findIndex(file => file.name === elem.name) === index
      )
      .map(file => file.originFileObj)
    const fileSignedList = fileList.filter(file => file.isSigned)
    const batchUploadArr = []
    const batchUploadArrTruc = []
    try {
      loadingAnimationStore.showSpinner(true)
      uploadFileList.forEach(file => {
        const formData = new FormData()
        formData.append('file', file)
        batchUploadArr.push(fileStore.uploadFile(formData))
      })
      const response = await Promise.all(batchUploadArr)
      const submitValuesInternal = {
        agency_external: agency_external,
        authority_issued_id: authority_issued_id,
        book_group_id: book_group_id,
        book_id: book_id,
        company_code_recipients: undefined,
        date_issued: date_issued
          ? moment(values.date_issued).toISOString()
          : null,
        document_number: document_number?.toUpperCase(),
        document_type: document_type,
        attachments: [
          ...fileTrinhKy.map(item => item.file_id),
          ...fileSignedList.map(file => file.id),
          ...annexFileList.map(file => file.file_id),
          ...fileTrinhKyDinhKem.map(file => file.file_id),
          ...response.map(response => response.data.file_id),
        ],
        sign_date: sign_date ? moment(values.sign_date).toISOString() : null,
        signer: signer,
        title: title,
        urgency_level: urgency_level,
        agency_issued: agency_issued,
        assign_user: {
          assignees: [],
        },
        receive_address: receive_address,
        is_sign: isReleaseDocument ? true : false,
      }

      const res = await internalDocumentStore.createInternalDocumentOutgoing(
        submitValuesInternal
      )
      let messageSuccess = 'Tạo văn bản đi nội bộ thành công!'

      if (isSendImsat) {
        const saved = getSavedImsatToken()
        const effectiveToken = imsatToken || saved.token
        const effectiveUsername = imsatUsername || saved.username

        const assignees = []
        followerList.forEach(follower => {
          const code = follower.id || follower.user_name || follower.username
          if (code) {
            assignees.push({
              assignee_code: code,
              assignee_type:
                follower.assignee_type === ASSIGNEE_TYPE.DEPARTMENT
                  ? 'DEPARTMENT'
                  : follower.assignee_type === ASSIGNEE_TYPE.GROUP
                  ? 'GROUP'
                  : 'USER',
              permission: 'VIEW',
            })
          }
        })

        const submitValuesImsat = {
          book_group_id: values.imsat_book_group_id,
          book_id: values.imsat_book_id,
          authority_issued_id: values.imsat_authority_issued_id,
          document_number: document_number?.toUpperCase(),
          document_type: document_type,
          sign_date: sign_date ? moment(values.sign_date).toISOString() : null,
          date_issued: date_issued
            ? moment(values.date_issued).toISOString()
            : null,
          signer: signer,
          urgency_level: urgency_level,
          title: title,
          agency_issued: agency_issued,
          receive_address: receive_address,
          attachments: submitValuesInternal.attachments,
          assign_user: {
            assignees,
          },
          username: effectiveUsername,
        }

        const imsatRes = await CrawlerRequest.createImsatOutgoing(
          submitValuesImsat,
          effectiveToken
        )

        if (!imsatRes.data?.success) {
          console.error('IMSAT error:', imsatRes.data?.error)
          message.warning(
            `Đã tạo văn bản CPCTM nhưng đồng bộ sang IMSAT báo lỗi: ${
              imsatRes.data?.error || 'Không xác định'
            }`
          )
        } else {
          messageSuccess = isReleaseDocument
            ? 'Phát hành tài liệu và gửi sang IMSAT thành công!'
            : 'Tạo văn bản đi nội bộ và gửi sang IMSAT thành công!'
        }
      }
      if (isReleaseDocument) {
        await electronicDocumentStore.updateElectronicDocumentStatus(
          {
            action: ELECTRONIC_DOCUMENT_STATUS.RELEASE,
            file_id: fileTrinhKy[0].file_id,
            outgoing_document_code: res?.data?.code,
            organizations: organizations?.map(item => item.label),
          },
          selectedElectronicDocument?.code
        )
        messageSuccess = 'Phát hành tài liệu thành công!'
      }
      if (isCreateDocTruc) {
        uploadFileList.forEach(file => {
          const formData = new FormData()
          formData.append('file', file)
          batchUploadArrTruc.push(fileStore.uploadFileLTVB(formData))
        })
        // Download file đã kí từ vimc hoặc file đã upload lên VIMC--> upload lại lên trục
        const uploadedData = [
          ...fileTrinhKy.map(item => ({
            id: item.file_id,
            name: item.file_name,
          })),
          ...fileSignedList,
          ...fileTrinhKyDinhKem.map(item => ({
            id: item.file_id,
            name: item.file_name,
          })),
          ...annexFileList.map(item => ({
            id: item.file_id,
            name: item.file_name,
          })),
        ]
        const fileIdUploadedList = uploadedData.map(item => item.id)
        const batchDownloadFileUploadedList = []
        fileIdUploadedList.forEach(fileId => {
          batchDownloadFileUploadedList.push(fileStore.downloadFile(fileId))
        })
        // 1. Download file uploaded từ vimc
        const responseUploaded = await Promise.all(
          batchDownloadFileUploadedList
        )
        const batchUploadFileList = []
        responseUploaded.forEach((item, index) => {
          const formData = new FormData()
          formData.append('file', item.data, uploadedData[index].name)
          batchUploadFileList.push(fileStore.uploadFileLTVB(formData))
        })
        // 2. upload lại file uploaded đc tải về từ VIMC lên trục
        const responseUploadedFileTruc = await Promise.all(batchUploadFileList)
        // 2. upload file chưa ký lên trục
        const responseUploadTruc = await Promise.all(batchUploadArrTruc)
        const attachmentsTruc = [
          ...responseUploadedFileTruc,
          ...responseUploadTruc,
        ].map(response => response.data.fileId)
        const submitValuesTruc = {
          attachments: attachmentsTruc,
          code: document_number,
          promulgationDate: date_issued,
          signer: signer,
          subject: title,
          listUserTo: listUserToValue,
        }
        await connectedDocumentStore.createOutgoingDocument(submitValuesTruc)
        messageSuccess = isReleaseDocument
          ? 'Phát hành tài liệu, đồng thời tạo văn bản liên thông trục thành công!'
          : 'Tạo văn bản đi nội bộ và văn bản liên thông trục thành công!'
      }
      message.success(messageSuccess)
      if (organizations?.length > 0) {
        // Tạo danh sách tất cả file (trừ file trình ký)
        const allFiles = [
          // File đã ký
          ...fileSignedList.map(file => ({
            file_id: file.id,
            file_name: file.name,
          })),
          // File phụ lục
          ...annexFileList.map(file => ({
            file_id: file.file_id,
            file_name: file.file_name,
          })),
          // File đính kèm trình ký
          ...fileTrinhKyDinhKem.map(file => ({
            file_id: file.file_id,
            file_name: file.file_name,
          })),
          // File mới upload
          ...response.map(res => ({
            file_id: res.data.file_id,
            file_name: res.data.file_name || res.data.original_name, // Đảm bảo lấy file_name từ response
          })),
        ]

        history.push('/cate-document/outgoing-document/create', {
          data: submitValuesInternal,
          extendData: {
            organizations: organizations,
            fileRelease: fileRelease,
            response: allFiles, // Gửi danh sách tất cả file (trừ file trình ký)
          },
        })
      } else {
        history.push('/internal-document/outgoing-document')
      }
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const onChangeCheckbox = async e => {
    if (!e.target.checked) {
      setIsCreateDocTruc(false)
      setSelectedUserListTruc([])
      userTrucStore.clearSelectUserDataTruc()
      userTrucStore.clearSelectGroupDataTruc()
      return
    }
    if (localStorage.getItem('jwtTruc')) {
      return setIsCreateDocTruc(true)
    }
    if (
      currentUser.commands.filter(command => command.code === TRUC_COMMAND)
        .length === 0
    ) {
      setIsCreateDocTruc(false)
      return message.warning(
        `Tài khoản của bạn không có quyền tạo văn bản đi liên thông ${systemName}!`
      )
    }
    const accountTruc = accountList.find(
      arr => arr.command.code === TRUC_COMMAND
    )
    if (!accountTruc) {
      setIsCreateDocTruc(false)
      return message.warning(
        `Vui lòng liên hệ admin tạo tài khoản liên thông ${systemName}, để có thể tạo văn bản đi liên thông ${systemName}!`
      )
    }
    try {
      loadingAnimationStore.showSpinner(true)
      await authenticationStore.userLoginTruc(
        accountTruc.account_name,
        accountTruc.password
      )
      setIsCreateDocTruc(true)
    } catch (err) {
      setIsCreateDocTruc(false)
      message.error(
        `Tài khoản liên thông ${systemName} của bạn sai, vui lòng liên hệ admin!`
      )
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    loadingAnimationStore.showSpinner(true)
    ;(async () => {
      try {
        authorityStore.setAuthorityIssuedsQueryParams({
          type: DOCUMENT_TYPE.OUTGOING,
          key: null,
        })
        await Promise.all([
          authorityStore.getAuthorityIssueds(),
          companyStore.getCompanyList(),
          bookStore.getBookGroup('DI'),
        ])
      } catch (err) {
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => {
      form.resetFields()
      bookStore.clearStore()
      signedDocumentStore.clearFilePDFSign()
      selectPeopleStore.clearSelectPeopleStore()
    }
  }, [])

  // For đổi tên file nhận từ thiết bị
  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    })
  }

  // sign popup
  const handleClosePopupSign = () => {
    setIsVisiblePopupSign(false)
    signedDocumentStore.clearFilePDFSign()
  }

  const handleOpenPopupSign = (file, index) => {
    setDataSignSavis({
      file: file.originFileObj,
      index: index,
    })
    const fileBlob = new Blob([file.originFileObj], { type: 'application/pdf' })
    signedDocumentStore.setFileBlob(fileBlob)
    signedDocumentStore.setOriginFileObj(file.originFileObj)
    setIsVisiblePopupSign(true)
  }

  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ['rename'],
      value: '',
    },
  ])

  const submitRenameFile = async value => {
    if (typeRename === 'FILE_DEFAULT') {
      const index = fileTargetRename?.index
      const newFileList = [...fileList]
      newFileList[index].name = value.rename + fileExt
      newFileList[index].originFileObj = renameFile(
        newFileList[index].originFileObj,
        newFileList[index].name
      )
      setFileList(newFileList)
      setIsModalVisibleRenameFile(false)
      message.success('Đổi tên file thành công!')
    }
    if (typeRename === 'FILE_SIGNED') {
      try {
        loadingAnimationStore.showSpinner(true)
        await fileStore.handleRenameFile(
          fileTargetRename.file_id,
          value.rename + fileExt
        )
        setIsModalVisibleRenameFile(false)
        const newFileList = [...fileList]
        newFileList[fileTargetRename.index] = {
          ...newFileList[fileTargetRename.index],
          name: value.rename + fileExt,
        }
        setFileList(newFileList)
        message.success('Đổi tên tài liệu thành công!')
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    }
    if (typeRename === 'FILE_RELEASE') {
      try {
        loadingAnimationStore.showSpinner(true)
        await fileStore.handleRenameFile(
          fileTrinhKy[0].file_id,
          value.rename + fileExt
        )
        setIsModalVisibleRenameFile(false)
        setFileTrinhKy([
          {
            file_id: fileTrinhKy[0].file_id,
            file_name: value.rename + fileExt,
          },
        ])
        await electronicDocumentStore.getElectronicDocumentById(
          selectedElectronicDocument.code
        )
        message.success('Đổi tên tài liệu thành công!')
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    }
    if (typeRename === 'FILE_RELEASE_ATTACHED') {
      try {
        loadingAnimationStore.showSpinner(true)
        await fileStore.handleRenameFile(
          fileTargetRename.file_id,
          value.rename + fileExt
        )
        setIsModalVisibleRenameFile(false)
        const newFileList = [...fileTrinhKyDinhKem]
        newFileList[fileTargetRename.index] = {
          file_id: fileTargetRename.file_id,
          file_name: value.rename + fileExt,
        }
        setFileTrinhKyDinhKem(newFileList)
        setNoSetFileTrinhKyDinhKem(true)
        await electronicDocumentStore.getElectronicDocumentById(
          selectedElectronicDocument.code
        )
        message.success('Đổi tên tài liệu thành công!')
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    }
    if (typeRename === 'ANNEX_FILE') {
      try {
        loadingAnimationStore.showSpinner(true)
        await fileStore.handleRenameFile(
          fileTargetRename.file_id,
          value.rename + fileExt
        )
        setIsModalVisibleRenameFile(false)
        const newAnnexFileList = [...annexFileList]
        newAnnexFileList[fileTargetRename.index] = {
          file_id: fileTargetRename.file_id,
          file_name: value.rename + fileExt,
        }
        setAnnexFileList(newAnnexFileList)
        await electronicDocumentStore.getElectronicDocumentById(
          selectedElectronicDocument.code
        )
        message.success('Đổi tên phụ lục thành công!')
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    }
  }

  const handleToggleAuthoritiesActionModalOutgoing = bool => event => {
    setIsVisbleAuthoritiesActionModalOutgoing(bool)
  }

  const filterSelectOption = (input, option) => {
    return (
      utils
        .nonAccentVietnamese(option.name)
        .indexOf(utils.nonAccentVietnamese(input)) >= 0
    )
  }

  return (
    <>
      <Form
        form={form}
        scrollToFirstError={true}
        name={'create-outgoing-document'}
        layout={'vertical'}
        style={{ paddingTop: '2rem' }}
        onFinish={onFinish}
        initialValues={{
          document_type: '021',
          document_number: dataSameDocument?.documentNumber || '',
          signer: dataSameDocument?.signer || '',
          title: dataSameDocument?.title || '',
          urgency_level: dataSameDocument?.urgencyLevel,
          authority_issued_id: defaultAuthorityIssuedId,
          date_issued: isReleaseDocument
            ? dataSameDocument?.dateIssued &&
              moment(dataSameDocument?.dateIssued)
            : null,
        }}>
        <Row type={'flex'} gutter={30}>
          <Col xs={24} md={12}>
            <Form.Item
              label={'Nhóm sổ văn bản'}
              name={'book_group_id'}
              rules={[
                { required: true, message: ' Vui lòng chọn nhóm sổ văn bản!' },
              ]}>
              <Select
                onChange={handleSelectBookGroupId}
                showSearch
                notFoundContent={<EmptyContent />}
                filterOption={true}
                optionFilterProp={'name'}
                placeholder={'-- Chọn nhóm sổ văn bản --'}>
                {bookGroupList.map(book => (
                  <Option key={book.id} value={book.id} name={book.name}>
                    {book.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label={'Sổ văn bản'}
              name={'book_id'}
              rules={[
                { required: true, message: ' Vui lòng chọn sổ văn bản!' },
              ]}>
              <Select
                style={{ width: '100%' }}
                showSearch
                notFoundContent={<EmptyContent />}
                filterOption={true}
                optionFilterProp={'name'}
                disabled={selectedBookGroupId === null}
                placeholder={'-- Chọn sổ văn bản --'}>
                {bookListOfGroup.map(book => (
                  <Option key={book.id} value={book.id} name={book.name}>
                    {book.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row type={'flex'} gutter={30}>
          <Col xs={24} md={12}>
            <Form.Item
              label={'Số hiệu'}
              name={'document_number'}
              rules={[
                { required: true, message: ' ' },
                { validator: validateDocumentNumber },
              ]}>
              <Input
                maxLength={50}
                placeholder={'Nhập số hiệu văn bản'}
                style={{ textTransform: 'uppercase' }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label={'Loại văn bản'}
              name={'document_type'}
              rules={[
                { required: true, message: ' Vui lòng chọn loại văn bản!' },
              ]}>
              <Select
                notFoundContent={<EmptyContent />}
                placeholder={'-- Chọn loại văn bản --'}>
                <Option value={'021'}>Công văn</Option>
                <Option value={'022'}>Quyết định</Option>
                <Option value={'024'}>Tờ trình</Option>
                <Option value={'020'}>Báo cáo</Option>
                <Option value={'025'}>Khác</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row type={'flex'} gutter={30}>
          <Col xs={24} md={12}>
            <Form.Item label={'Ngày ký'} name={'sign_date'}>
              <DatePicker
                style={{ width: '100%' }}
                format={DATE_TIME_FORMAT_DEFAULT}
                showTime={{ defaultValue: dayjs('00:00', 'HH:mm') }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label={'Ngày ban hành'} name={'date_issued'}>
              <DatePicker
                style={{ width: '100%' }}
                format={DATE_TIME_FORMAT_DEFAULT}
                showTime={{ defaultValue: dayjs('00:00', 'HH:mm') }}
                disabled={isReleaseDocument}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row type={'flex'} gutter={30}>
          <Col xs={24} md={12}>
            <Form.Item label={'Người ký'} name={'signer'}>
              <Input maxLength={500} placeholder={'Nhập tên người ký'} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label={'Độ khẩn'} name={'urgency_level'}>
              <Select
                allowClear
                notFoundContent={<EmptyContent />}
                placeholder={'-- Chọn độ khẩn --'}>
                <Option value={'001'}>Khẩn</Option>
                <Option value={'002'}>Hỏa tốc</Option>
                <Option value={'003'}>Hỏa tốc hẹn giờ</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label={'Trích yếu'}
          name={'title'}
          rules={[
            { required: true, message: ' Vui lòng nhập trích yếu văn bản!' },
            { validator: validator.validateInputString },
          ]}>
          <TextArea
            autoSize={{ minRows: 4 }}
            placeholder={'Nhập trích yếu văn bản'}
          />
        </Form.Item>
        {isReleaseDocument && fileTrinhKy?.length > 0 && (
          <div style={{ marginBottom: 5 }}>
            <div style={{ marginBottom: 4 }}>Tài liệu phát hành:</div>
            <UploadFileListItem>
              <div>
                <PaperClipOutlined style={{ color: blue, marginRight: 6 }} />
                <span
                  onClick={() =>
                    fileStore.handleDownloadFile(
                      fileTrinhKy[0].file_id,
                      fileTrinhKy[0].file_name
                    )
                  }>
                  {fileTrinhKy[0]?.file_name}
                </span>
              </div>
              <Button
                className={'rename'}
                type="text"
                onClick={() => {
                  setTypeRename('FILE_RELEASE')
                  setFileExt(
                    '.' + utils.getExtensionFile(fileTrinhKy[0].file_name)
                  )
                  setIsModalVisibleRenameFile(true)
                  setFieldsRenameFile([
                    {
                      name: ['rename'],
                      value:
                        fileTrinhKy[0].file_name &&
                        utils.removeExtensionFile(fileTrinhKy[0].file_name),
                    },
                  ])
                }}>
                Đổi tên
              </Button>
            </UploadFileListItem>
          </div>
        )}
        {annexFileList.length > 0 && (
          <div style={{ marginBottom: 5 }}>
            <div style={{ marginBottom: 4 }}>Phụ lục đính kèm:</div>
            {annexFileList.map((file, index) => (
              <UploadFileListItem key={file.file_id}>
                <div>
                  <PaperClipOutlined style={{ color: blue, marginRight: 6 }} />
                  <span
                    onClick={() =>
                      fileStore.handleDownloadFile(file.file_id, file.file_name)
                    }>
                    {file.file_name}
                  </span>
                </div>
                <Button
                  className={'rename'}
                  type="text"
                  onClick={() => {
                    setTypeRename('ANNEX_FILE')
                    setFileExt('.' + utils.getExtensionFile(file.file_name))
                    setFileTargetRename({
                      ...file,
                      index: index,
                    })
                    setIsModalVisibleRenameFile(true)
                    setFieldsRenameFile([
                      {
                        name: ['rename'],
                        value:
                          file.file_name &&
                          utils.removeExtensionFile(file.file_name),
                      },
                    ])
                  }}>
                  Đổi tên
                </Button>
              </UploadFileListItem>
            ))}
          </div>
        )}
        <Form.Item
          name={'attachments'}
          label={'Tài liệu đính kèm'}
          rules={[
            {
              required: !isReleaseDocument,
              message: ' Vui lòng chọn tài liệu đính kèm!',
            },
          ]}>
          <Upload
            valuePropName={'fileList'}
            fileList={fileList}
            multiple={true}
            beforeUpload={() => false}
            onChange={handleChangeFile}
            showUploadList={false}>
            <Button icon={<UploadOutlined />}>Chọn tài liệu đính kèm</Button>
          </Upload>
        </Form.Item>
        {isProcessing && (
          <div style={{ margin: '0 70px 0 0' }}>
            <Progress
              percent={progressPercent}
              status={progressPercent === 100 ? 'success' : 'active'}
              showInfo={true}
              strokeColor={{
                '0%': '#108ee9',
                '100%': '#87d068',
              }}
              format={percent => `  Đang xử lý ${percent}%`}
            />
          </div>
        )}
        {fileTrinhKyDinhKem.map((file, index) => {
          return (
            <UploadFileListItem key={file.file_id}>
              <div>
                <PaperClipOutlined style={{ color: blue, marginRight: 6 }} />
                <span
                  onClick={() =>
                    fileStore.handleDownloadFile(file.file_id, file.file_name)
                  }>
                  {file.file_name}
                </span>
              </div>
              <div>
                <Button
                  className={'rename'}
                  type="text"
                  onClick={() => {
                    setTypeRename('FILE_RELEASE_ATTACHED')
                    setFileExt('.' + utils.getExtensionFile(file.file_name))
                    setFileTargetRename({
                      ...file,
                      index: index,
                    })
                    setIsModalVisibleRenameFile(true)
                    setFieldsRenameFile([
                      {
                        name: ['rename'],
                        value:
                          file.file_name &&
                          utils.removeExtensionFile(file.file_name),
                      },
                    ])
                  }}>
                  Đổi tên
                </Button>
                <Tooltip title={'Xoá tập tin'}>
                  <DeleteOutlined
                    style={{ color: redPrimary }}
                    onClick={() =>
                      setFileTrinhKyDinhKem(
                        fileTrinhKyDinhKem.filter(
                          el => el.file_id !== file.file_id
                        )
                      )
                    }
                  />
                </Tooltip>
              </div>
            </UploadFileListItem>
          )
        })}

        {
          <UploadFileListWrapper>
            {fileList.map((file, index) => (
              <UploadFileListItem
                key={file.uid}
                isSigned={file.isSigned}
                isNotPDF={file.type !== 'application/pdf'}>
                <FileTextOutlined />
                <span>{file.name}</span>
                {file.isSigned ? (
                  <Button
                    className={'digital-signature'}
                    type="text"
                    onClick={() => message.info('Đã ký!')}>
                    Đã ký
                  </Button>
                ) : file.type !== 'application/pdf' ? (
                  <AccessControlAction
                    aclActionType={ACL_ACTION_TYPE.ky_so__OUTGOING}>
                    <Button
                      className={'digital-signature'}
                      type="text"
                      onClick={() =>
                        message.info(
                          'Chỉ ký được file PDF, vui lòng chọn file khác!'
                        )
                      }>
                      Ký số
                    </Button>
                  </AccessControlAction>
                ) : (
                  <AccessControlAction
                    aclActionType={ACL_ACTION_TYPE.ky_so__OUTGOING}>
                    <Popconfirm
                      placement="top"
                      title={'Hãy chọn loại ký'}
                      onConfirm={() => handleOpenPopupSign(file, index)}
                      okText="Ký tùy chọn"
                      cancelText="Ký mặc đinh"
                      onCancel={() => handleSignSavis(file, index)}>
                      <Button
                        className={'digital-signature'}
                        type="text"
                        onClick={() => handleBeforeSign(file, index)}>
                        Ký số
                      </Button>
                    </Popconfirm>
                  </AccessControlAction>
                )}
                {
                  <Button
                    className={'rename'}
                    type="text"
                    onClick={() => {
                      if (file.isSigned) {
                        setTypeRename('FILE_SIGNED')
                      } else {
                        setTypeRename('FILE_DEFAULT')
                      }
                      setFileExt('.' + utils.getExtensionFile(file.name))
                      setFileTargetRename({
                        file_id: file.file_id || file.id,
                        index: index,
                      })
                      setIsModalVisibleRenameFile(true)
                      setFieldsRenameFile([
                        {
                          name: ['rename'],
                          value:
                            file.name && utils.removeExtensionFile(file.name),
                        },
                      ])
                    }}>
                    Đổi tên
                  </Button>
                }
                <Tooltip title={'Xoá tập tin'}>
                  <DeleteOutlined
                    onClick={() =>
                      handleRemoveFileFromUploadList(file.uid, index)
                    }
                  />
                </Tooltip>
              </UploadFileListItem>
            ))}
          </UploadFileListWrapper>
        }

        <Form.Item label={'Nơi nhận'} name={'receive_address'}>
          <Input maxLength={50} placeholder={'Nhập nơi nhận'} />
        </Form.Item>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '30px',
          }}>
          <Form.Item
            style={{ width: '100%' }}
            label={'Bộ phận dự thảo'}
            name={'authority_issued_id'}
            rules={[
              { required: true, message: 'Vui lòng chọn bộ phận dự thảo!' },
            ]}>
            <Select
              allowClear
              showSearch
              showArrow
              filterOption={filterSelectOption}
              notFoundContent={<EmptyContent />}
              placeholder={'-- Chọn cơ quan ban hành --'}>
              {authorityIssuedsList.map(authorityIssued => (
                <Option
                  name={authorityIssued.name}
                  value={authorityIssued.id}
                  key={authorityIssued.id}>
                  {authorityIssued.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Button onClick={handleToggleAuthoritiesActionModalOutgoing(true)}>
            Tạo mới
          </Button>
        </div>

        <Form.Item label={'Nhập bộ phận dự thảo'} name={'agency_issued'}>
          <TextArea
            autoSize={{ minRows: 4 }}
            placeholder={
              'Nhập bộ phận dự thảo (nếu không có trong danh sách bên trên)'
            }
          />
        </Form.Item>
        <Form.Item name={'organizations'} label={'Công ty nhận'}>
          <DebounceSelect
            mode="multiple"
            placeholder={'-- Chọn công ty nhận văn bản --'}
            fetchOptions={listOrgan}
            style={{
              width: '100%',
            }}
          />
        </Form.Item>

        <div style={{ marginTop: 15, marginBottom: 15 }}>
          <Checkbox checked={isSendImsat} onChange={onChangeCheckboxImsat}>
            <span>Gửi văn bản sang IMSAT</span>
          </Checkbox>
        </div>

        {isSendImsat && (
          <div
            style={{
              background: '#ffffff',
              border: '1px solid #d9e8fb',
              borderRadius: '8px',
              padding: '18px 24px',
              marginTop: 12,
              marginBottom: 24,
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.04)',
            }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingBottom: 14,
                marginBottom: 18,
                borderBottom: '1px solid #f0f0f0',
                flexWrap: 'wrap',
                gap: 10,
              }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span
                  style={{
                    display: 'inline-block',
                    width: 4,
                    height: 18,
                    background: '#1890ff',
                    borderRadius: 2,
                    marginRight: 8,
                  }}
                />
                <span
                  style={{ fontSize: 15, fontWeight: 600, color: '#096dd9' }}>
                  Thông tin gửi và đồng bộ sang IMSAT (Vinacomin)
                </span>
              </div>
              <Space wrap size={8}>
                <Tag
                  color="blue"
                  style={{
                    borderRadius: 12,
                    padding: '2px 10px',
                    marginRight: 0,
                    fontSize: 12,
                  }}>
                  Tài khoản:{' '}
                  <strong>{imsatUsername || currentUser?.username}</strong>
                </Tag>
                <Button
                  size="small"
                  loading={loadingImsatMetadata}
                  onClick={() => {
                    const saved = getSavedImsatToken()
                    loadImsatMetadata(
                      imsatToken || saved.token,
                      imsatUsername || saved.username
                    )
                  }}>
                  Làm mới dữ liệu IMSAT
                </Button>
                <Button size="small" onClick={() => openImsatLoginModal()}>
                  Đổi tài khoản / Đăng nhập lại
                </Button>
              </Space>
            </div>

            <Row type={'flex'} gutter={30}>
              <Col xs={24} md={12}>
                <Form.Item
                  label={'Nhóm sổ văn bản IMSAT'}
                  name={'imsat_book_group_id'}
                  rules={[
                    {
                      required: isSendImsat,
                      message: 'Vui lòng chọn nhóm sổ văn bản IMSAT!',
                    },
                  ]}>
                  <Select
                    onChange={handleSelectImsatBookGroupId}
                    showSearch
                    loading={loadingImsatMetadata}
                    notFoundContent={<EmptyContent />}
                    filterOption={true}
                    optionFilterProp={'name'}
                    placeholder={'-- Chọn nhóm sổ văn bản IMSAT --'}>
                    {imsatBookGroupList.map(book => (
                      <Option key={book.id} value={book.id} name={book.name}>
                        {book.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label={'Sổ văn bản IMSAT'}
                  name={'imsat_book_id'}
                  rules={[
                    {
                      required: isSendImsat,
                      message: 'Vui lòng chọn sổ văn bản IMSAT!',
                    },
                  ]}>
                  <Select
                    showSearch
                    loading={loadingImsatBooks}
                    notFoundContent={<EmptyContent />}
                    filterOption={true}
                    optionFilterProp={'name'}
                    disabled={!selectedImsatBookGroupId}
                    placeholder={'-- Chọn sổ văn bản IMSAT --'}>
                    {imsatBookList.map(book => (
                      <Option key={book.id} value={book.id} name={book.name}>
                        {book.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row type={'flex'} gutter={30}>
              <Col xs={24} md={24}>
                <Form.Item
                  label={'Cơ quan ban hành / Bộ phận dự thảo IMSAT'}>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <Form.Item
                      name={'imsat_authority_issued_id'}
                      rules={[
                        {
                          required: isSendImsat,
                          message: 'Vui lòng chọn cơ quan ban hành IMSAT!',
                        },
                      ]}
                      style={{ flex: 1, marginBottom: 0 }}>
                      <Select
                        style={{ width: '100%' }}
                        showSearch
                        loading={loadingImsatMetadata}
                        notFoundContent={<EmptyContent />}
                        filterOption={true}
                        optionFilterProp={'name'}
                        placeholder={'-- Chọn cơ quan ban hành IMSAT --'}>
                        {imsatAuthorityIssuedsList.map(ai => (
                          <Option key={ai.id} value={ai.id} name={ai.name}>
                            {ai.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Button
                      icon={<PlusOutlined />}
                      disabled={!isSendImsat}
                      onClick={() => setImsatAuthorityModalVisible(true)}>
                      Tạo mới
                    </Button>
                  </div>
                </Form.Item>
              </Col>
            </Row>

            <Row type={'flex'} gutter={30} style={{ marginTop: 5 }}>
              <Col xs={24} md={24}>
                <SelectTitle>
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: '#262626',
                    }}>
                    Chọn người theo dõi:
                  </span>
                  <Space>
                    <Tooltip title="Chọn người dùng" color={blue}>
                      <Button
                        icon={<UserOutlined style={{ color: blue }} />}
                        onClick={handleOpenImsatFollowerUserPopup}
                      />
                    </Tooltip>
                    <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                      <Button
                        icon={<TeamOutlined />}
                        style={{ color: yellowPrimary }}
                        onClick={handleOpenImsatFollowerGroupPopup}
                      />
                    </Tooltip>
                  </Space>
                </SelectTitle>
                <SelectList>
                  {followerList.map(el => (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Tag>
                  ))}
                </SelectList>
              </Col>
            </Row>
          </div>
        )}
        {isCreateDocTruc && (
          <div
            style={{
              boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px',
              padding: '10px',
              marginTop: 20,
            }}>
            <Title level={5} style={{ margin: '10px 0 15px 0' }}>
              Thông tin văn bản đi liên thông {systemName}
            </Title>
            <SelectTitle>
              <span>
                <span
                  style={{
                    color: '#ff4d4f',
                    fontFamily: 'SimSun, sans-serif',
                    marginRight: '-4px',
                  }}>
                  *{' '}
                </span>
                <span style={{ marginRight: '10px' }}>Công ty nhận:</span>
              </span>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() => handleOpenSelectUserPopupTruc(false)}
                  />
                </Tooltip>
                <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                  <Button
                    icon={<TeamOutlined />}
                    style={{ color: yellowPrimary }}
                    onClick={() => handleOpenSelectGroupPopupTruc(false)}
                  />
                </Tooltip>
              </Space>
            </SelectTitle>
            <SelectList>
              {selectedUserListTruc.map(el => (
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={el.id}
                  closable
                  onClose={() => userTrucStore.handleRemoveSelectTruc(el)}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={22}
                    name={el.name}
                    icon={typeof el.id === 'number' && <TeamOutlined />}
                  />
                </Tag>
              ))}
            </SelectList>
          </div>
        )}

        <FormActionFooter>
          <Button
            onClick={() => {
              form.resetFields()
              setNoSetFileTrinhKyDinhKem(false)
              setIsSendImsat(false)
              handleCancel()
            }}>
            Huỷ bỏ
          </Button>
          <Button
            style={{ marginLeft: 10 }}
            type={'primary'}
            htmlType={'submit'}>
            {isReleaseDocument ? 'Phát hành văn bản' : 'Tạo văn bản'}
          </Button>
        </FormActionFooter>
      </Form>

      <PopupSign
        isVisiblePopupSign={isVisiblePopupSign}
        handleClosePopupSign={handleClosePopupSign}
        hiddenSelectDocument
      />
      <PopupRenameFile
        isModalVisibleRenameFile={isModalVisibleRenameFile}
        handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
        submitRenameFile={submitRenameFile}
        fieldsRenameFile={fieldsRenameFile}
        fileExt={fileExt}
      />
      {renderDocument()}
      {renderPopupTruc()}

      {isVisibleAuthoritiesActionModalOutgoing && (
        <AuthoritiesActionModalOutgoing
          disabledAuthoritiesTypePicker
          tabActive={DOCUMENT_TYPE.OUTGOING}
          payloadModal={{
            status: true,
            isCreate: true,
            updatePayLoad: null,
          }}
          handleCloseModal={handleToggleAuthoritiesActionModalOutgoing(false)}
        />
      )}

      <SelectPeoplePopup
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        isSendType={isSendType}
        setIsSendType={setIsSendType}
      />
      <SelectGroupPopup
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
      />

      <SyncImsatCredentialsModal
        title="Đăng nhập tài khoản IMSAT (Vinacomin)"
        okText="Đăng nhập"
        allowChangeUsername={true}
        visible={imsatLoginModalVisible}
        username={imsatUsername}
        onUsernameChange={setImsatUsername}
        password={imsatPassword}
        onPasswordChange={setImsatPassword}
        rememberPassword={imsatRememberPassword}
        onRememberPasswordChange={setImsatRememberPassword}
        hasSavedPassword={imsatHasSavedPassword}
        error={imsatLoginError}
        loading={imsatLoginLoading}
        onOk={handleImsatLogin}
        onCancel={handleCancelImsatLogin}
      />
      <Modal
        visible={imsatAuthorityModalVisible}
        title="Tạo mới cơ quan ban hành IMSAT"
        okText="Tạo mới"
        cancelText="Hủy"
        confirmLoading={creatingImsatAuthority}
        onCancel={() => {
          setImsatAuthorityModalVisible(false)
          imsatAuthorityForm.resetFields()
        }}
        onOk={() => imsatAuthorityForm.submit()}>
        <Form
          form={imsatAuthorityForm}
          layout="vertical"
          onFinish={handleCreateImsatAuthorityIssued}>
          <Form.Item
            label="Tên cơ quan ban hành / Bộ phận dự thảo"
            name="name"
            rules={[
              {
                required: true,
                whitespace: true,
                message: 'Vui lòng nhập tên cơ quan ban hành!',
              },
            ]}>
            <Input
              maxLength={255}
              placeholder="Nhập tên cơ quan ban hành IMSAT"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

InternalDocumentOutgoingDocCreateForm.propTypes = {}

export default memo(
  inject(
    'commonStore',
    'internalDocumentStore',
    'fileStore',
    'authenticationStore',
    'authorityStore',
    'loadingAnimationStore',
    'companyStore',
    'bookStore',
    'connectedDocumentStore',
    'commonStore',
    'signedDocumentStore',
    'selectPeopleStore',
    'accountStore',
    'userTrucStore',
    'electronicDocumentStore',
    'cateStore',
    'ScanPdfStore',
    'sameDocumentStore'
  )(observer(InternalDocumentOutgoingDocCreateForm))
)
